<p class="pr-6 text-black">فیلتر زمانی</p>
<mat-card class="demo-inline-calendar-card">
  <mat-calendar
    [(selected)]="selectedDateRange"
    (selectedChange)="rangeChanged($event)"
    (yearSelected)="selectYear($event)"
    *ngIf="selectorType == 'normal'"
  ></mat-calendar>
  <mat-calendar
    [(selected)]="selectedDateRange"
    (selectedChange)="rangeChanged($event)"
    (yearSelected)="selectYear($event)"
    startView="multi-year"
    *ngIf="selectorType == 'yearOnly'"
  ></mat-calendar>
</mat-card>
